import { render, staticRenderFns } from "./ChangeLoginPwdModal.vue?vue&type=template&id=6b511f24&scoped=true"
import script from "./ChangeLoginPwdModal.vue?vue&type=script&lang=js"
export * from "./ChangeLoginPwdModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeLoginPwdModal.vue?vue&type=style&index=0&id=6b511f24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b511f24",
  null
  
)

export default component.exports